// Inline feedback for setting a new password. The Shopify package enforces the full policy
// server-side (including the breached-password check) and returns its message on rejection
import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_POLICY_MESSAGES,
} from '@unified-commerce/gpc-vue-storefront-shopify';
import { extend } from 'vee-validate';

extend('passwordmin', {
  validate: (value) => (value ?? '').trim().length >= PASSWORD_MIN_LENGTH,
  message: PASSWORD_POLICY_MESSAGES.tooShort,
});

extend('passwordnotcurrent', {
  params: [{ name: 'target', isTarget: true }],
  validate: (value, { target }) => value !== target,
  message: PASSWORD_POLICY_MESSAGES.reused,
});
